// extracted by mini-css-extract-plugin
export default {"info":"info_info__NkU-c","description":"info_description__FFBXY","title":"info_title__15HJp","about":"info_about__GgUqY","cartIcon":"info_cartIcon__T0mmK"};